<template>
  <v-dialog
    v-model="isDialogVisible"
    persistent
    max-width="600px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">Office</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form
            class="multi-col-validation"
            @submit.prevent=""
          >
            <v-row>
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="form.name"
                  :error-messages="errors.name"
                  label="Office Name"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          outlined
          @click="isDialogVisible = false"
        >
          Close
        </v-btn>
        <v-btn
          color="success"
          :disabled="saving"
          @click="create"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from '@axios'
import { ref } from '@vue/composition-api'

const formInit = () => ({
  name: '',
})

export default {
  setup(props, { emit }) {
    const saving = ref(false)
    const isDialogVisible = ref(false)

    const form = ref(formInit())
    const errors = ref([])
    const create = () => {
      saving.value = true
      axios
        .post('/offices', form.value)
        .then(r => {
          saving.value = false
          isDialogVisible.value = false
          emit('saved', r.data)
        })
        .catch(error => {
          if (error.response.status === 422) {
            errors.value = error.response.data.errors
          }
          saving.value = false
        })
    }

    return {
      form,
      errors,
      saving,

      isDialogVisible,

      create,
    }
  },
}
</script>
